/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */

export type StaffBrandReviewControllerListV1StateItem =
  (typeof StaffBrandReviewControllerListV1StateItem)[keyof typeof StaffBrandReviewControllerListV1StateItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffBrandReviewControllerListV1StateItem = {
  open: 'open',
  approved: 'approved',
  auto_cleared: 'auto_cleared',
  rejected: 'rejected',
} as const;
